import axios from 'axios';

// Create an axios instance with a base URL.
// It reads the base URL from an environment variable, with a fallback for development.
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
});

// Use an interceptor to add the auth token from localStorage to every request.
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;